import styled from 'styled-components';

import { SelectColor } from '../../../../../services/reports';

export const RenderStyleSVG = styled.div`
	svg.icon-men {
		.st0 {
			fill: ${props => SelectColor(props.channel, 'men')};
		}
	}
	
	svg.icon-women {
		.st0 {
			fill: ${props => SelectColor(props.channel, 'women')};
		}
	}
`;

export const StyledPieChartWithCustomizedLabel = styled.div`
  width: 100%;
  max-width: 440px;

  @media screen and (max-width: 1370px) {
    max-width: 320px;
  }
  
  @media screen and (max-width: 1240px) {
    max-width: 100%;
  }

  .recharts-wrapper {
    svg {
      transform: scale(1.4) translateX(-72px) translateY(-43px);
      
      @media screen and (max-width: 800px) {
        transform: scale(1.4) translateX(-65px) translateY(-43px);
      }
    }
  }
  
  .legend-people {
    transform: translate3d(0, 20px, 0);
    margin: 0 10px;
  }
`;

export const CustomColorSquare = styled.div`
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px !important;
  border-radius: 2px;
  background-color: ${props => props.color};
`;
